module.exports = __webpack_public_path__ + "18a81d43652c0f91aa924ed6f33d5989.ttf";